/**
 * @generated SignedSource<<884eb293ef592a2fbbcf83f9051cdfce>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type OfficePolicyEnum = "hybrid" | "in_office" | "remote";
import { FragmentRefs } from "relay-runtime";
export type OfficePolicyInfo_Job$data = {
  readonly officePolicy: OfficePolicyEnum | null | undefined;
  readonly " $fragmentType": "OfficePolicyInfo_Job";
};
export type OfficePolicyInfo_Job$key = {
  readonly " $data"?: OfficePolicyInfo_Job$data;
  readonly " $fragmentSpreads": FragmentRefs<"OfficePolicyInfo_Job">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "OfficePolicyInfo_Job",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "officePolicy",
      "storageKey": null
    }
  ],
  "type": "Job",
  "abstractKey": null
};

(node as any).hash = "cc23e4f75d1fb4a1fd9497e288466210";

export default node;
